import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import deepEqual from 'deep-equal'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { IFtpConfig } from '@/models/iris/ftp/IFtpConfig'
import { SyncPathsArr } from '@/enum/SyncPath'
import { AloMission } from '@/models/alo/AloMission'
import store from '@/store'

// Props
interface Props {
  mission: AloMission
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionDetailFtp',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: AloMission
};



// Reactive data
const configFtp = ref({
  enableFtp: true,
  login: '',
  password: '',
  port: 21,
  server: '',
  tls: true,
  dstPaths: '',
  syncPaths: [] as string[]
})

// Computed properties

const originalFtpConfig = computed(() => {
  if (props.mission.gliId == null) return null
  return store.myGetters.originalFtpConfigs[props.mission.gliId]
})

const modifiedFtpConfig = computed(() => {
  if (props.mission.gliId == null) return null
  return store.myGetters.modifiedFtpConfigs[props.mission.gliId]
})

const loadingFtp = computed(() => store.myGetters.ftpLoading)

const btnActifFtp = computed(() => {
  if (!originalFtpConfig.value) return false
  const configFtpCopy = loadConfigFtp({}, originalFtpConfig.value)
  return !deepEqual(configFtpCopy, configFtp.value) && !loadingFtp.value
})

// Methods
function loadConfigFtp(target: any, config: IrisConfigContainer<IFtpConfig>) {
  if (config) {
    target.enableFtp = config.mod_settings.EnabledMOD['module-FTP']
    target.login = config.mod_settings.FTP.login
    target.password = config.mod_settings.FTP.password
    target.port = Number.parseInt(config.mod_settings?.FTP?.port?.toString()) || 21
    target.server = config.mod_settings.FTP.server
    target.tls = config.mod_settings.FTP.tls
    target.dstPaths = config.mod_settings.Data.dst_paths
    target.syncPaths = Array.isArray(config.mod_settings.Data.sync_paths) ? config.mod_settings.Data.sync_paths : []
  }
  return target
}

function validateConfigFtp() {
  if (props.mission.gliId == null) return

  store.myActions.GLIDER_UPDATE_MODIFIED_FTP({
    itemId: props.mission.gliId,
    newProperties: {
      mod_settings: {
        EnabledMOD: {
          'module-FTP': configFtp.value.enableFtp
        },
        FTP: {
          login: configFtp.value.login,
          password: configFtp.value.password,
          port: configFtp.value.port,
          server: configFtp.value.server,
          tls: configFtp.value.tls
        },
        Data: {
          dst_paths: configFtp.value.dstPaths,
          sync_paths: configFtp.value.syncPaths.filter((p) => SyncPathsArr.some((pa) => pa == p))
        }
      }
    }
  })
}

function saveConfigFtp() {
  validateConfigFtp()
  if (props.mission.gliId != null) {
    store.myActions.GLIDER_IRIS_FTP_SAVE_REQUEST(props.mission.gliId)
  }
}

function restoreConfigFtp() {
  if (props.mission.gliId != null) {
    store.myActions.GLIDER_CANCEL_MODIFIED_FTP(props.mission.gliId)
  }
}

// Watchers
watch(
  () => props.mission,
  (newValue) => {
    if (newValue.gliId != null) {
      store.myActions.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST(newValue.gliId)
    }
  }
)

watch(
  modifiedFtpConfig,
  (newConfig: IrisConfigContainer<IFtpConfig> | null, oldConfig: IrisConfigContainer<IFtpConfig> | null) => {
    if (newConfig && !deepEqual(newConfig, oldConfig)) {
      configFtp.value = loadConfigFtp({}, newConfig)
    }
  },
  { deep: true }
)

watch(
  configFtp,
  () => {
    validateConfigFtp()
  },
  { deep: true }
)

// Created lifecycle
if (props.mission.gliId != null) {
  store.myActions.GLIDER_IRIS_FTP_REQUEST(props.mission.gliId).then(() => {
    if (modifiedFtpConfig.value) {
      configFtp.value = loadConfigFtp({}, modifiedFtpConfig.value)
    }
  })
}

return { __sfc: true,props, configFtp, originalFtpConfig, modifiedFtpConfig, loadingFtp, btnActifFtp, loadConfigFtp, validateConfigFtp, saveConfigFtp, restoreConfigFtp, SyncPathsArr }
}

})